"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var estiloSwitch = require('./Switch.module.scss');
var react_1 = __importStar(require("react"));
var Switch = function (_a) {
    var id = _a.id, nomeGrupo = _a.nomeGrupo, _b = _a.estaAtivado, estaAtivado = _b === void 0 ? false : _b, _c = _a.valor, valor = _c === void 0 ? false : _c, _d = _a.estilo, estilo = _d === void 0 ? "primaryLight" : _d, _e = _a.tamanho, tamanho = _e === void 0 ? 'regular' : _e, _f = _a.desabilitado, desabilitado = _f === void 0 ? false : _f, style = _a.style, styleBackground = _a.styleBackground, onChange = _a.onChange;
    var _g = react_1.default.useState(valor !== null && valor !== void 0 ? valor : estaAtivado), ativado = _g[0], setAtivado = _g[1];
    var switchStyle = desabilitado ? estiloSwitch.disabled : estiloSwitch[estilo] || "";
    var switchSize = estiloSwitch[tamanho] || "";
    var handleChange = function (event) {
        setAtivado(!ativado);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
    };
    (0, react_1.useEffect)(function () {
        setAtivado(valor !== null && valor !== void 0 ? valor : estaAtivado);
    }, [valor, estaAtivado]);
    return (react_1.default.createElement("div", { className: "".concat(estiloSwitch.container, " ").concat(switchSize), style: style },
        react_1.default.createElement("input", { type: "checkbox", id: id, name: nomeGrupo, disabled: desabilitado, checked: ativado, onChange: handleChange }),
        react_1.default.createElement("div", { className: "".concat(estiloSwitch.switch, " ").concat(switchStyle, " ").concat(switchSize) }),
        react_1.default.createElement("div", { className: "".concat(estiloSwitch.backgroundElement, " \n                ").concat(switchStyle, " ").concat(switchSize), style: styleBackground })));
};
exports.Switch = Switch;
